export default function InputError({ message }) {
  if (!message) return null;

  const finalMsg =
    typeof message === "string"
      ? message
      : message.msg || JSON.stringify(message);

  return <p className="input-error">{finalMsg}</p>;
}
